<template>
    <modal name="delete-warning">
        <div class="p-4 d-flex justify-content-between h-100 flex-column">
            <div>
                <h4 class="mb-3">
                    {{ title }}
                </h4>

                <p>
                    {{ description }}
                </p>
            </div>

            <div class="d-flex">
                <button
                    class="btn btn-secondary mr-3"
                    @click="$modal.hide('delete-warning')"
                >
                    <span>No</span>
                </button>

                <button
                    class="btn btn-danger"
                    @click="$emit('delete')"
                >
                    <span>Yes</span>
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: 'DeleteWarningModal',

    props: {
        title: {
            type: String,
            required: true,
        },

        description: {
            type: String,
            required: true,
        },
    },
};
</script>

<style>

</style>
